import { useApi } from "@backstage/core-plugin-api";
import { useCallback, useEffect } from "react";
import { useAsyncFn } from "react-use";
import { opsReviewApiRef } from "../api/OpsReviewApi";

export interface Props {}

export const useTeamBreakdownData = ({}: Props) => {
  const api = useApi(opsReviewApiRef);

  const getData = useCallback(async () => {
    const { data } = await api.getTeamViolationData();
    return data;
  }, [api]);

  const [state, fetchData] = useAsyncFn(async () => {
    return getData();
  }, [getData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    loading: state.loading,
    error: state.error,
    value: state?.value,
    fetchData,
  };
};
